module.exports = __webpack_public_path__ + "media/images/trolley-998187c2771357cf3b3dcbe195b446c1.svg";